import { graphql } from '../generated';

export const GET_INVOICES = graphql(`
  query GetInvoices($first: Int!, $after: String) {
    viewer {
      workspace {
        id
        invoices(first: $first, after: $after) {
          nodes {
            id
            billedAt
            description
            amountCents
            currency
            status
          }
          endCursor
          hasNextPage
        }
      }
    }
  }
`);
